





































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class BaseSelect extends Vue {
  @Prop({ type: String, required: false }) private id!: string;
  @Prop({ type: String, required: false, default: '' }) private name!: string;
  @Prop({ type: Array, required: true, default: () => [] }) private options!: any[];
  @Prop({ type: String, required: false, default: '' }) private selected!: string;
  @Prop({ type: String, required: false, default: '' }) private placeholder!: string;
  @Prop({ type: String, required: false, default: '' }) private autocomplete!: string;
  @Prop({ type: Array, required: false, default: () => [] }) private validations!: any[];
}
